export function endDateAfterStartDate<
  T extends { startDate?: Date; endDate?: Date },
>(data: T): boolean {
  const { startDate, endDate } = data;
  return startDate && endDate ? endDate >= startDate : true;
}
